import { AspectRatio, Flex, FlexProps, Skeleton, Stack } from '@mantine/core'

type Props = FlexProps

export const _Skeleton = (props: Props) => {
  return (
    <>
      {[...new Array(10)].map((_v, i) => (
        <Flex key={i} gap={16} {...props} h={144}>
          <AspectRatio ratio={1} w={96} h="fit-content">
            <Skeleton height={96} width={96} radius="xl" />
          </AspectRatio>
          <Stack w="100%">
            <Skeleton height={19} width="100%" />
            <Skeleton height={48} mt={2} />
          </Stack>
        </Flex>
      ))}
    </>
  )
}
